import Vue from 'vue';
import App from '@/App.vue';
import router from './router/router';
import store from './store/store';
import Antd from 'ant-design-vue';
import { printVersion } from './Utils/version';
import VueCompositionAPI from '@vue/composition-api';
printVersion();
// import 'ant-design-vue/dist/antd.less';

Vue.use(Antd);
Vue.use(VueCompositionAPI);
Vue.config.productionTip = false;
require('@/assets/font/iconfont.js');
import '@/assets/font/iconfont.css';
require('@/assets/font_2033331_hfi48kq1kxv/iconfont.js');
import '@/assets/font_2033331_hfi48kq1kxv/iconfont.css';
const eventBus = new Vue({ store });
const VueInstance = new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');

export { VueInstance, eventBus };
